import { ICardHUProps } from "../../Interfaces";
import { Container, Title, Type, Description, LinkTo } from "./style";
import { useUser } from "../../Providers/User";
import { useHabUnits } from "../../Providers/HabUnit";
import ReservedInfos from "./ReservedInfo";
import OccpuiedInfos from "./OccupiedInfo";
import AvailableInfos from "./AvaliableInfo";
import MaintenanceInfos from "./MaintenanceInfo";
import { HUForm } from "../HUForm";
import { useState } from "react";
import ModalElement from "../Modal";
import { GearButton } from "../GearButton";
import { CloseButton } from "../CloseButton";

const CardHU = ({ data, isInPage }: ICardHUProps) => {
  const { type, title, description, state, reserves, id } = data;
  const { admAuth } = useUser();
  const { deleteHU } = useHabUnits();
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

  const handleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };
  let isReserved = reserves?.length > 0 || state === "reserved";
  return (
    <Container>
      <Title>{title}</Title>
      <Type>{type}</Type>
      <Description>{description}</Description>
      {isReserved && (
        <ReservedInfos data={data} isInPage={isInPage} state={state} />
      )}
      {state === "occupied" && (
        <OccpuiedInfos
          data={data}
          isInPage={isInPage}
          isReserved={isReserved}
        />
      )}
      {state === "available" && (
        <AvailableInfos
          data={data}
          isInPage={isInPage}
          isReserved={isReserved}
        />
      )}
      {state === "maintenance" && (
        <MaintenanceInfos
          data={data}
          isInPage={isInPage}
          isReserved={isReserved}
        />
      )}
      <LinkTo to={`/unitHabits/${id}`}>ver mais</LinkTo>
      {admAuth && (
        <>
          <div className="buttons">
            <CloseButton deleteHU={deleteHU} HU={data} />
            <GearButton showModal={handleModal} />
          </div>

          <ModalElement isOpen={modalIsOpen} closeModal={handleModal}>
            <p style={{ textAlign: "center" }}>Editar unidade habitacional</p>
            <HUForm HU={data} closeModal={handleModal} />
          </ModalElement>
        </>
      )}
    </Container>
  );
};

export default CardHU;
